export default __webpack_public_path__ + "static/media/pag4.bbf88d2c.jpg";